import React, { useEffect, useState } from "react"
import { Box, Grid, Typography } from "@mui/material"
import { FEATURED_RECIPIE_IDS } from "../constants"
import RecipeCard from "./recipeCard"

const PopularRecipes = () => {
  const [recipes, setRecipes] = useState([])

  useEffect(() => {
    const fetchRecipes = async () => {
      try {
        // Join IDs into a comma-separated string
        const ids = FEATURED_RECIPIE_IDS.join(",")

        // Fetch recipes from the backend
        const response = await fetch(`/api/recipes/byIDs?ids=${ids}`)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        const fetchedRecipes = await response.json()
        setRecipes(fetchedRecipes)
      } catch (error) {
        console.error("Error fetching recipes:", error)
      }
    }

    fetchRecipes()
  }, [])

  return (
    <Box mt={4}>
      <Typography variant="h4" component="div" mb={2}>
        Featured Favourites
      </Typography>
      <Grid container spacing={4}>
        {recipes.length === 0 ? (
          <Typography>No recipes found</Typography>
        ) : (
          recipes.map((recipe) => (
            <Grid item xs={12} md={3} key={recipe._id}>
              <RecipeCard recipe={recipe} />
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  )
}

export default PopularRecipes
